import React from 'react'
import { Provider } from 'react-redux'
import store from './store'
import GBForm from './formSections';
import EUAcknowledgementPage from '../Acknowledgement/acknowledgement';
import EUHeader from '../../header'

function GBApp(props) {
  
  return (
    <Provider store={store}>
      <EUHeader 
        translate={props.translate}
        shipId={props.shipId}
        shipmentCountry={props.shipmentCountry}
        kxUser={props.kxUser}
        {...props.headerProps} 
        version={props.version}
        kxEngineUserInfo={props?.kxEngineUserInfo}
        showSendToBillingButton={props?.showSendToBillingButton}
      />
      { 
      props.finalReview ?
        <EUAcknowledgementPage
        euPdf={props.euPdf}
        key='finalReview'
        handleLegalAcknowledgement={props.handleLegalAcknowledgement}
        loadShipment={props.loadShipment}
        translate = {props.translate}
        countryCheck = {props.currentJobData?.countryCode}
      />
       : <GBForm {...props} kxEngineUserInfo={props?.kxEngineUserInfo} />

      }
    </Provider>
  )
}

export default React.memo(GBApp);
